package landing.ds


import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.ui.graphics.painter.Painter
import loadResourceImage
import loadResourceString
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import truematchmp.composeapp.generated.resources.Res
import truematchmp.composeapp.generated.resources.ai_slogan
import truematchmp.composeapp.generated.resources.connect_slogan
import truematchmp.composeapp.generated.resources.focus_slogan
import truematchmp.composeapp.generated.resources.games_slogan
import truematchmp.composeapp.generated.resources.slogan_ai
import truematchmp.composeapp.generated.resources.slogan_ai_description
import truematchmp.composeapp.generated.resources.slogan_connect
import truematchmp.composeapp.generated.resources.slogan_connect_description
import truematchmp.composeapp.generated.resources.slogan_focus
import truematchmp.composeapp.generated.resources.slogan_focus_description
import truematchmp.composeapp.generated.resources.slogan_games
import truematchmp.composeapp.generated.resources.slogan_games_description
import truematchmp.composeapp.generated.resources.slogan_tasty_cashback
import truematchmp.composeapp.generated.resources.slogan_tasty_cashback_description
import truematchmp.composeapp.generated.resources.tasty_cashback

@Immutable
data class ResourceSlogan(
    val title: StringResource,
    val description: StringResource,
    val image: DrawableResource
){
    companion object{
        val resourceSlogans = listOf(
            ResourceSlogan(
                title = Res.string.slogan_connect,
                description = Res.string.slogan_connect_description,
                image = Res.drawable.connect_slogan),
            ResourceSlogan(
                title = Res.string.slogan_ai,
                description = Res.string.slogan_ai_description,
                image = Res.drawable.ai_slogan),
            ResourceSlogan(
                title = Res.string.slogan_games,
                description = Res.string.slogan_games_description,
                image = Res.drawable.games_slogan),
            ResourceSlogan(
                title = Res.string.slogan_tasty_cashback,
                description = Res.string.slogan_tasty_cashback_description,
                image = Res.drawable.tasty_cashback),
            ResourceSlogan(
                title = Res.string.slogan_focus,
                description = Res.string.slogan_focus_description,
                image = Res.drawable.focus_slogan),
        )
    }
}